// ── Color thresholds ────────────────────────────────────────────────
export function pc(v) {
  return v >= 85 ? "var(--red)" : v >= 65 ? "var(--orange)" : "var(--green)";
}
export function tc(v) {
  return v >= 75 ? "var(--red)" : v >= 60 ? "var(--orange)" : "var(--green)";
}
export function gaugeCSS(val, color) {
  return `conic-gradient(${color} ${val * 1}%, rgba(255,255,255,.05) 0)`;
}

// ── Formatters ──────────────────────────────────────────────────────
// Uptime tính bằng giây (metrics phần cứng)
export function fmtUptime(s) {
  if (!s) return "—";
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  return d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function fmtNet(kbps) {
  if (kbps == null || kbps < 0) return "—";
  if (kbps >= 1024) return (kbps / 1024).toFixed(1) + " MB/s";
  return kbps.toFixed(1) + " KB/s";
}

export function fmtGB(gb) {
  return gb != null ? gb.toFixed(1) + " GB" : "—";
}

export function fmtBytes(b) {
  if (!b) return "0 MB";
  return (b / 1048576).toFixed(1) + " MB";
}

// Thời gian cảnh báo: backend đã lưu sẵn theo giờ Việt Nam dưới dạng
// chuỗi không kèm múi giờ (vd "2026-06-08 09:47:16.393"), nên KHÔNG được
// chuyển đổi múi giờ — chỉ lấy thẳng HH:MM:SS từ chuỗi để không phụ thuộc
// múi giờ của máy/trình duyệt.
export function fmtVnTime(value) {
  if (!value) return "—";
  if (typeof value === "string") {
    const m = value.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
    if (m) return `${m[3]}/${m[2]} ${m[4]}:${m[5]}:${m[6]}`;
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

// PM2 uptime: startMs là timestamp bắt đầu (ms)
export function fmtPm2Uptime(startMs, status) {
  if (status !== "online" || !startMs) return "—";
  let s = Math.floor((Date.now() - startMs) / 1000);
  const d = Math.floor(s / 86400);
  s %= 86400;
  const h = Math.floor(s / 3600);
  s %= 3600;
  const m = Math.floor(s / 60);
  if (d) return `${d}d ${h}h`;
  if (h) return `${h}h ${m}m`;
  if (m) return `${m}m ${s % 60}s`;
  return `${s}s`;
}

// ── Server status derivation ────────────────────────────────────────
export function svStatus(sv) {
  if (!sv.IsOnline || !sv.isConnected) return "offline";
  const m = sv.metrics || {};
  if ((m.cpuUsage || 0) > 85 || (m.ramPct || 0) > 90 || (m.diskPct || 0) > 90)
    return "warn";
  return "online";
}

export const STATUS_DOT = {
  online: "s-online",
  warn: "s-warn",
  offline: "s-offline",
};
export const STATUS_BADGE_CLS = {
  online: "b-online",
  warn: "b-warn",
  offline: "b-offline",
};
export const STATUS_BADGE_TXT = {
  online: "ONLINE",
  warn: "WARNING",
  offline: "OFFLINE",
};
export const STATUS_ACCENT = {
  online: "acc-green",
  warn: "acc-orange",
  offline: "acc-red",
};
export const STATUS_CTRL_ACCENT = {
  online: "cca-green",
  warn: "cca-orange",
  offline: "cca-red",
};
